export default __webpack_public_path__ + "static/media/success.0e451cc3.svg";